var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 80,
    viewBox: "0 0 34 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9069 79.7512H21.0539C19.7546 79.264 18.758 78.6365 18.1452 77.3298C18.0492 77.1231 17.6654 76.0821 17.6654 75.9566V49.3354C17.3701 48.9737 16.7056 48.9885 16.4325 49.3354V75.8016C16.4325 76.4291 15.7754 77.6324 15.3546 78.1271C13.0144 80.9103 8.45203 79.6552 7.8319 76.0747L7.71378 30.0746C7.12319 29.3142 6.45138 29.7719 6.3997 30.6135L6.33326 50.0442C5.25542 52.8421 1.90378 52.5099 0.855469 49.8817V25.276C1.49036 21.9465 3.97825 19.5029 7.40372 19.2371C13.6862 18.7425 20.6183 19.5988 26.9746 19.2592C30.4296 19.6801 32.9544 22.3377 33.2424 25.8149C32.8142 33.3819 33.7961 41.5469 33.2424 49.0401C32.9914 52.4287 29.0417 53.1522 27.7498 50.0515L27.6834 30.6135C27.6317 29.6021 26.672 29.2994 26.2955 30.3108V75.964C26.0149 77.8834 24.6639 79.1532 22.8995 79.7512H22.9069Z",
    fill: "#F4EAD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0431 16.1804C21.3568 16.1804 24.8537 12.6703 24.8537 8.34025C24.8537 4.01023 21.3568 0.500061 17.0431 0.500061C12.7294 0.500061 9.23242 4.01023 9.23242 8.34025C9.23242 12.6703 12.7294 16.1804 17.0431 16.1804Z",
    fill: "#F4EAD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManWhite);
export default __webpack_public_path__ + "static/media/man-white.abdc7ed0da13728fae6817941a4dadf9.svg";
export { ForwardRef as ReactComponent };